import React from "react";

const Java_max = () => {
  return (
    <div>
      <h1>Java max</h1>
      <p>This page provides explanations, examples, and common use-cases for Java max in Java.</p>
    </div>
  );
};

export default Java_max;
